import registrationSelection from './registrationSelection.vue'
export default registrationSelection
